import { IconCrownUpgrade } from '@gto/ui/assets'
import { gradients } from '@gto/ui/theme/design-tokens'
import { Typography } from '@gto/ui/typography'

export type DealDescriptionRowProps = {
  text: string
  exclusive: boolean
}

export const DealDescriptionRow = ({ text, exclusive }: DealDescriptionRowProps) => {
  if (!text) {
    return null
  }

  return (
    <div
      className="flex w-auto max-w-full items-center gap-1 rounded-md px-1.5 py-1 text-primary-main sm:px-1 sm:py-0.5"
      style={{
        background: exclusive ? gradients.primary.horizontal(0.08, 0.08) : undefined,
      }}
    >
      {exclusive ? (
        <IconCrownUpgrade
          color="inherit"
          height={12}
          style={{ flex: '0 0 auto' }}
          width={12}
        />
      ) : (
        <div className="m-0.5 size-2 flex-[0_0_auto] rounded-full bg-text-ghost" />
      )}
      <Typography
        className="uppercase sm:normal-case"
        color={exclusive ? 'primary' : 'text.primary'}
        variant="body3"
      >
        {text}
      </Typography>
    </div>
  )
}
